<template>
    <div>

        <div style="display: flex; flex-direction: row; justify-content: start; align-items: center; font: normal normal normal 20px/30px Poppins;">
            <img v-if="icon" :src="require('@/assets/img/icon/' + icon + '.png')" style="max-height: 50px;">
            <div v-else style="width: 50px; height: 50px;"></div>
            <span style="color: #343434; font-size: 20px; margin-left: 10px; font: normal normal normal 20px/30px Poppins;">{{ title }}</span>
        </div>
        <p class="text-center pt-3 mb-0" style="font-size: 40px; font: normal normal normal 40px/60px Poppins;">{{ value }}</p>

    </div>
</template>

<script>
    export default {
        data () {
            return {

            }
        },
        props : [
            'title',
            'value',
            'icon'
        ],
        mounted () {

        },
        methods : {

        }
    }
</script>

<style scoped>
    .highlight--stats {
        background-color: white;
        border-radius: 8px;
        /* box-shadow: 0px 3px 10px #0000000F; */
        padding: 50px 20px;

        display: flex;
        flex-direction: column;
        /* align-items: center; */
        justify-content: center;
    }

    .value--unit {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-end;
    }
    
    .stats--title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
        font: normal normal normal 20px/30px Poppins;
    }

    .stats--value {
        font-size: 40px;
        font-weight: bold;
        color: #545454;
        font: normal normal normal 40px/60px Poppins;
    }

    .stats--unit {
        font-size: 14px;
        font-weight: 500;
        color: #D1D1D1;
        padding: 0 0 10px 10px;
    }
</style>